import { render, staticRenderFns } from "./rejectGadai.vue?vue&type=template&id=60076afe&scoped=true&"
import script from "./rejectGadai.vue?vue&type=script&lang=js&"
export * from "./rejectGadai.vue?vue&type=script&lang=js&"
import style0 from "./rejectGadai.vue?vue&type=style&index=0&id=60076afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60076afe",
  null
  
)

export default component.exports